import React from 'react'

const Log = () => {
  return (
    <div>Log Kayıtları</div>
  )
}

export default Log